import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Dialog from 'components/Dialog';
import { useForm, useTranslation } from 'hooks';
import Form from './Form';

function OtherActivities({ language, otherActivities, syncErrors, syncing, onSave }) {
  const didMountRef = useRef(false);
  const { t, tr } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  
  // Only render if this is a modal route (background state exists)
  const isModal = location.state?.background;
  const isOpen = isModal && location.pathname.endsWith('/other-activities');

  const { useInput, handleReset, handleSubmit } = useForm({
    initialValues: otherActivities,
    onSubmit: onSave
  });

  const handleClose = useCallback(() => {
    handleReset?.();
    navigate(`/resume/${id ?? ''}`);
  }, [handleReset, navigate, id]);

  useEffect(() => {
    if (didMountRef.current) {
      if (!syncErrors && !syncing) {
        handleClose();
      }
    } else {
      didMountRef.current = true;
    }
  }, [handleClose, syncErrors, syncing]);

  // Don't render if not a modal
  if (!isModal) return null;

  return (
    <Dialog
      actionLabel={t('button.save')}
      disabled={syncing}
      open={isOpen}
      syncing={syncing}
      title={tr('title.otherActivities')}
      onAction={handleSubmit}
      onClose={handleClose}
    >
      <Form data-test-id="other-activities-form" language={language} useInput={useInput} />
    </Dialog>
  );
}

OtherActivities.propTypes = {
  otherActivities: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  syncErrors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  syncing: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired
};

export default OtherActivities;
